/**
 * Hook for GET /me/activity-calendar (T13.1 / ISSUE-073 / ADR-0020).
 *
 * Fetches a per-day logging presence calendar for the requested date range.
 * D-07: never shows streaks or gap counts — count-based only.
 */
import type { ActivityCalendarResponse } from '@nutians/shared/schemas';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api.js';

export function useActivityCalendar(from: string, to: string, enabled = true) {
  return useQuery<ActivityCalendarResponse>({
    queryKey: ['activity-calendar', from, to],
    queryFn: async (): Promise<ActivityCalendarResponse> => {
      const { data, error } = await api.GET('/me/activity-calendar', {
        params: { query: { from, to } },
      });
      if (error || !data) throw new Error('GET /me/activity-calendar failed');
      return data as ActivityCalendarResponse;
    },
    enabled,
    staleTime: 5 * 60_000,
    retry: false,
  });
}
